import React from "react";
import Layout from "../components/Layout";

const LandingPage = () => {
    const [sectionTitle, setSectionTitle] = React.useState("SECTION");
    const [isLoading, setIsLoading] = React.useState(false);

    const [pageInputs, setPageInputs] = React.useState({
        theme: "Simple",
        brand_name: "Night Shift Fuel",
        has_brand_logo: false,
        main_headline: "Fuel Your Night Shift",
        subheading:
            "Healthy, convenient snack boxes made for night shift workers. Get access to fresh food, protein snacks, drinks, and treats delivered when you need them most.",
        primary_color: "#0e4253",
        secondary_color: "#a8ccdc",
        primary_button_text: "Join the Early Access List &rarr;",
        primary_button_action: "Submit Form",
        primary_button_function: [{ "label": "email_address", "type": "text" }, { "label": "Occupation", "type": "options", "options": "Nurse, Firefighter" }],
        secondary_button_text: "See What's Inside",
        secondary_button_action: "Redirect to Url",
        secondary_button_function: [{ "label": "Destination URL", "value": "url or mailto:email" }],
        call_to_action_headline: "Be First When Night Shift Fuel Launches",
        call_to_action_description:
            "We're opening early access for night shift workers interested in convenient, affordable food options during long shifts.",
        call_to_action_button_text: "Get Early Access",
        background_image: "https://i.postimg.cc/c47gHsn1/nsf-banner.png",
        WebhookURL: "https://example-form-action-url.com"
    });

    const [pageData, setPageData] = React.useState([
        {
            "title": "Fuel for the Night Shift",
            "subtitle": "Convenient, affordable food options designed for overnight workers",
            "features": [
                {
                    "icon": "📦",
                    "title": "Curated Snack Boxes",
                    "description": "Each box includes a light meal, protein snacks, fruit, drinks, and a sweet treat."
                },
                {
                    "icon": "⏱️",
                    "title": "Ready When You Are",
                    "description": "No cooking, no vending machines, no late-night food runs."
                },
                {
                    "icon": "🌙",
                    "title": "Made for Overnight Work",
                    "description": "Designed specifically for long shifts when options are limited."
                }
            ]
        },
        {
            "title": "Who Night Shift Fuel Is For",
            "subtitle": "Built for people who work while the rest of the world sleeps",
            "features": [
                {
                    "icon": "🏥",
                    "title": "Healthcare Workers",
                    "description": "Nurses, technicians, and hospital staff on overnight shifts."
                },
                {
                    "icon": "🏭",
                    "title": "Warehouse & Factory Teams",
                    "description": "Physically demanding work that needs real fuel."
                },
                {
                    "icon": "🛡️",
                    "title": "Security & Emergency Staff",
                    "description": "Long hours with few food options available."
                }
            ]
        }
    ]);

    const addRow = () => {
        if (pageInputs.theme === "Shop") {
            setPageData(prev => [
                ...prev,
                {
                    title: "New Menu Item",
                    price: 0.00,
                    description: "",
                    imageUrl: "",
                }
            ]);
        }
        else {
            setPageData(prev => [
                ...prev,
                {
                    title: "New Section Title",
                    subtitle: "",
                    features: [{
                        icon: "",
                        title: "",
                        description: "",
                    }]
                }
            ]);
        }
    }

    const removeRow = (indexToRemove) => {
        setPageData(prev => {
            const newRows = prev.filter((_, index) => index !== indexToRemove);

            return newRows;
        });
    }

    const updateInputData = (theme) => {
        setIsLoading(true);
        let inputs = {};
        let defaultInputs = {
            theme: pageInputs.theme,
            brand_name: pageInputs.brand_name,
            main_headline: pageInputs.main_headline,
            subheading: pageInputs.subheading,
            primary_color: pageInputs.primary_color,
            secondary_color: pageInputs.secondary_color,
            background_image: pageInputs.background_image,
        }
        if (theme === "Showcase") {
            inputs = {
                ...defaultInputs,
                theme,
                sections: "About, Products, Contact",
                tag: "SNACK BOX"
            };
        }
        else if (theme === "Shop") {
            setSectionTitle("MENU ITEM");
            inputs = {
                ...defaultInputs,
                theme,
                address: "1234 Main Street",
                email: "nsf@gmail.com",
                phone: "123-457-8899",
                currency: "$",
                instagram_link: "https://google.com",
                facebook_link: "https://google.com",
                payment_instruction: "Please make payment to the cashapp id $nsf",
                order_confirmation_text: "Thank you for stuff",
                subscribe_instructions: "Updates and Plans",
            };
            setPageData([
                {
                    title: "Veggie Delight",
                    price: 4.99,
                    description: "A colorful mix of roasted vegetables and quinoa, served warm and freshly made",
                    imageUrl: "https://www.sourcesplash.com/i/random?q=food",
                },
                {
                    title: "Chicken Fajitas",
                    price: 12.59,
                    description: "Sizzling chicken breast strips served with sautéed onions, bell peppers, and warm flour tortillas, served with a side of mixed greens",
                    imageUrl: "https://www.sourcesplash.com/i/random?q=food",
                }
            ]);
        }
        else {
            setSectionTitle("SECTION");
            inputs = {
                ...defaultInputs,
                theme,
                has_brand_logo: false,
                primary_button_text: "Join the Early Access List &rarr;",
                primary_button_action: "Submit Form",
                primary_button_function: [{ "label": "email_address", "type": "text" }, { "label": "Occupation", "type": "options", "options": "Nurse, Firefighter" }],
                secondary_button_text: "See What's Inside",
                secondary_button_action: "Redirect to Url",
                secondary_button_function: [{ "label": "Destination URL", "value": "url or mailto:email" }],
                call_to_action_headline: "Be First When Night Shift Fuel Launches",
                call_to_action_description:
                    "We're opening early access for night shift workers interested in convenient, affordable food options during long shifts.",
                call_to_action_button_text: "Get Early Access",
                WebhookURL: "https://example-form-action-url.com"
            }
            setPageData([
                {
                    "title": "Fuel for the Night Shift",
                    "subtitle": "Convenient, affordable food options designed for overnight workers",
                    "features": [
                        {
                            "icon": "📦",
                            "title": "Curated Snack Boxes",
                            "description": "Each box includes a light meal, protein snacks, fruit, drinks, and a sweet treat."
                        },
                        {
                            "icon": "⏱️",
                            "title": "Ready When You Are",
                            "description": "No cooking, no vending machines, no late-night food runs."
                        },
                        {
                            "icon": "🌙",
                            "title": "Made for Overnight Work",
                            "description": "Designed specifically for long shifts when options are limited."
                        }
                    ]
                },
                {
                    "title": "Who Night Shift Fuel Is For",
                    "subtitle": "Built for people who work while the rest of the world sleeps",
                    "features": [
                        {
                            "icon": "🏥",
                            "title": "Healthcare Workers",
                            "description": "Nurses, technicians, and hospital staff on overnight shifts."
                        },
                        {
                            "icon": "🏭",
                            "title": "Warehouse & Factory Teams",
                            "description": "Physically demanding work that needs real fuel."
                        },
                        {
                            "icon": "🛡️",
                            "title": "Security & Emergency Staff",
                            "description": "Long hours with few food options available."
                        }
                    ]
                }
            ]);
        }
        setPageInputs(inputs);
        setIsLoading(false);
    }

    const handlePageInputChange = (k, v) => {
        setPageInputs(prev => ({
            ...prev,
            [k]: v
        }));

        if (k === "theme") {
            updateInputData(v);
        }
    };

    function handlePageDataChange(i, k, v) {

        setPageData((prev) => {
            const updated = [...prev];

            const keys = k.replace(/\[(\d+)\]/g, '.$1').split('.');

            let obj = updated[i];
            for (let j = 0; j < keys.length - 1; j++) {
                obj = obj[keys[j]];
            }

            obj[keys[keys.length - 1]] = v;

            return updated;
        });
    }

    function removeFeatureData(i, f) {
        setPageData(prev => {
            const updated = [...prev];
            const features = updated[i].features || [];
            updated[i] = {
                ...updated[i],
                features: features.filter((_, index) => index !== f)
            };
            return updated;
        });
    }

    function addFeatureData(i) {
        setPageData(prev => {
            const updated = [...prev];
            const features = updated[i].features || [];
            const newFeature = { icon: "", title: "", description: "" };
            updated[i] = {
                ...updated[i],
                features: [...features, newFeature]
            };
            return updated;
        });
    }

    if (isLoading) {
        return (<div>loading</div>)
    }

    return (
        <Layout
            header="Create a Landing Page"
            description="Download a static HTML landing page you can host anywhere."
            name="LANDING PAGE" data={pageData} addData={addRow} handleDataChange={handlePageDataChange}
            removeData={removeRow} inputData={pageInputs} handleInputDataChange={handlePageInputChange}
            optional={{ createNew: true, removeFeatureData: removeFeatureData, addFeatureData: addFeatureData, newButtonText: sectionTitle }}
            styles={["Simple", "Shop"]} />
    )
}

export default LandingPage;